import React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import {DashboardID} from '/constant/TestIDs';
import {withCompetency, withTheme} from '/provider/ThemeProvider';
import {white} from '/theme/color/on.color';
import {mineShaft} from '/theme/color/secondary.color';
import {withHOC} from '/util/hoc.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './OEBox.style';

interface OEBoxProps {
  isChecked: boolean;
  number: number;
  getTheme: (key: string) => string;
  key: number | null;
  testID: string | null;
}

export const OEBox: React.FC<OEBoxProps> = ({
  key = null,
  number = 0,
  isChecked = false,
  getTheme = noop,
  testID = null,
}) => {
  const checkedBoxStyle = {
    ...styles.box,
    backgroundColor: getTheme('competency.textColor.color'),
  };

  const boxStyle = isChecked
    ? checkedBoxStyle
    : {...styles.box, ...styles.notFilledBox};

  const numberStyle = {
    ...styles.number,
    color: isChecked ? white : mineShaft,
  };
  return (
    <View style={boxStyle} key={key}>
      <View
        style={styles.content}
        {...testProperties(
          testID
            ? testID + 'view'
            : DashboardID.dashboardProgressBarOrderingEntitiesBox,
          true,
        )}>
        <Text
          accessible={false}
          style={numberStyle}
          variant="caption"
          {...testProperties(
            `${testID ?? DashboardID.dashboardOrderingEntitiesNumber}-${
              isChecked ? 'checked' : 'unchecked'
            }`,
          )}>
          {number}
        </Text>
        {isChecked && (
          <Icon
            accessible={false}
            style={styles.icon}
            name="check"
            {...testProperties(
              testID
                ? testID + '-icon-checked'
                : DashboardID.dashboardOrderingEntitiesNumberChecked + '-icon',
            )}
          />
        )}
      </View>
    </View>
  );
};

export const OEBoxConnected = withHOC(withTheme, withCompetency)(OEBox);
